import { render, staticRenderFns } from "./ChangeFriendlyIdModal.vue?vue&type=template&id=41e8d494"
import script from "./ChangeFriendlyIdModal.vue?vue&type=script&lang=ts"
export * from "./ChangeFriendlyIdModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41e8d494')) {
      api.createRecord('41e8d494', component.options)
    } else {
      api.reload('41e8d494', component.options)
    }
    module.hot.accept("./ChangeFriendlyIdModal.vue?vue&type=template&id=41e8d494", function () {
      api.rerender('41e8d494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/ChangeFriendlyIdModal.vue"
export default component.exports